import TutorialGuide from '@/components/Guide/index.vue'
import { ref } from 'vue'

export default {
  install(app, options) {
    // 全局状态
    const guideData = ref({})
    const showGlobalGuide = ref(false)
     const completedGuides = ref({})
 // 初始化已完成引导
    const initCompletedGuides = () => {
      const saved = localStorage.getItem('completedGuides')
      if (saved) {
        completedGuides.value = JSON.parse(saved)
      }
    }
    initCompletedGuides()     // 全局方法：更新引导数据
    //  // 标记为已完成的方法
    const markAsCompleted = (path) => {
      completedGuides.value[path] = true
      localStorage.setItem('completedGuides', JSON.stringify(completedGuides.value))
    }
    //     const updateGuideData = (data) => {
    //   guideData.value = data
    // }
    
    // 全局方法：显示/隐藏引导
    // const toggleGuide = (show) => {
    //   showGlobalGuide.value = show
    // }
    
    // 注册全局组件
    app.component('TutorialGuide', TutorialGuide)
    
    // 提供全局方法
    app.provide('guide', {
      guideData,
      showGlobalGuide,
      completedGuides,
      markAsCompleted, // 确保提供这个方法
      updateGuideData: (data) => {
        guideData.value = data
      },
      toggleGuide: (show) => {
        showGlobalGuide.value = show
      }
    })
  }
}